import React from 'react'

const Footer = () => {
  return (
    <>
        <footer className="text-center">
            <p>© 2022 Tech Optimization.All Rights Reserved.</p>
        </footer>
    </>
  )
}

export default Footer